import { t } from "@lingui/macro";
import { useAtomValue, useSetAtom } from "jotai";

import { Button } from "@whoosh/design-system/src/components/controls";
import {
  ArrowLeftIcon,
  CloseIcon,
} from "@whoosh/design-system/src/components/icons_v2/general";
import { PoweredByWhooshStacked } from "@whoosh/design-system/src/components/icons_v2/special/PoweredByWhooshStacked";
import { HStack, VStack } from "@whoosh/design-system/src/components/primitive";

import { GoBackToPreviousVerificationStepAtom } from "../atoms/actions";
import {
  isVerifyingEmailOrPhoneAtom,
  shouldCloseOnBackPressAtom,
} from "../atoms/stores";
import { ClubLogo } from "./ClubLogo";
import { ClubLogoNotificationsFragment_session$key } from "./__generated__/ClubLogoNotificationsFragment_session.graphql";

type ManageNotificationsHeaderProps = {
  sessionRef: ClubLogoNotificationsFragment_session$key | null;
  setIsOpen: (isOpen: boolean) => void;
};

export const ManageNotificationsHeader = ({
  sessionRef,
  setIsOpen,
}: ManageNotificationsHeaderProps) => {
  const goBackToInitialStep = useSetAtom(GoBackToPreviousVerificationStepAtom);

  const setIsVerifyingEmailOrPhone = useSetAtom(isVerifyingEmailOrPhoneAtom);

  const shouldCloseOnBackPress = useAtomValue(shouldCloseOnBackPressAtom);
  const goBack = useSetAtom(GoBackToPreviousVerificationStepAtom);

  const handleClose = () => {
    if (shouldCloseOnBackPress) {
      setIsVerifyingEmailOrPhone(null);
      setIsOpen(false);
      goBackToInitialStep();
    } else {
      goBack();
    }
  };

  return (
    <VStack gap={6}>
      <HStack justifyContent={"space-between"} alignItems={"center"}>
        <Button
          onPress={() => handleClose()}
          variant="secondary"
          leftIcon={shouldCloseOnBackPress ? <CloseIcon /> : <ArrowLeftIcon />}
          accessibilityLabel={t`Back button`}
        />
        <HStack>
          <PoweredByWhooshStacked />
          {sessionRef ? <ClubLogo sessionRef={sessionRef} /> : null}
        </HStack>
      </HStack>
    </VStack>
  );
};
